module.exports = __webpack_public_path__ + "static/media/preguntas-frecuentes.86f9a525.pdf";